import {sprintf} from 'sprintf-js';
import translate, {translateOrNull} from '../translate';

export const getTicketPriceText = (currency) => {
  return {
    free: translate('ticketPriceInformationModule', 'FREE'),
    from: translate('ticketPriceInformationModule', 'TICKET_PRICE_RANGE_FROM'),
    ticketServiceFee: translate('ticketPriceInformationModule', 'TICKET_SERVICE_FEE'),
    freeEvent: translate('ticketPriceInformationModule', 'FREE_EVENT'),
    serviceFeePrefix: translate('ticketPriceInformationModule', 'SERVICE_FEE_RANGE_PREFIX'),
    serviceFeeSuffix: translate('ticketPriceInformationModule', 'SERVICE_FEE_RANGE_SUFFIX'),
    currency:         currency,
    deliveryFeeInfo: translate('deliveryFeeModule', 'DELIVERY_FEE_INFO'),
    paymentFeeInfo:  translateOrNull('deliveryFeeModule', 'PAYMENT_FEE_INFO'),
    deliveryCosts: translate('deliveryFeeModule', 'DELIVERY_FEE_LABLE'),
    ticketPrice: translate('ticketPriceInformationModule', 'TICKET_PRICE')
  };
};

export const getTicketPriceRange = (priceObjArray) => {
  const sorted = priceObjArray.sort((a, b) => {
    if (a.price < b.price) return -1;
    if (a.price > b.price) return 1;
    return 0;
  });

  return {min: sorted[0], max: sorted[sorted.length - 1]};
};

/**
 * Returns a ticket price string for the given price range.
 *
 * @param priceRange The price range to generate the string from
 * @param text An object containing constious translated strings for
 * use in building the range string
 *
 * @returns {String}
 */
export const getTicketPriceRangeString = (priceRange, text, moneyFormat) => {
  const min = priceRange.min;
  const max = priceRange.max;

  if (max.price === 0) {
    // Free event
    return text.freeEvent;
  }

  if (min.price === 0) {
    const total    = max.price / 100;
    const decimals = Math.round((total % 1) * 100);
    return `${text.from} ${text.free} - ${sprintf(moneyFormat, total, decimals, text.currency)}`;
  }

  if (min.price === max.price) {
    const total    = max.price / 100;
    const decimals = Math.round((total % 1) * 100);
    return `${text.ticketPrice} ${sprintf(moneyFormat, total, decimals, text.currency)}`;
  }
  else {
    const maxTotal    = max.price / 100;
    const maxDecimals = Math.round((maxTotal % 1) * 100);
    const minTotal    = min.price / 100;
    const minDecimals = Math.round((minTotal % 1) * 100);
    const minFormatted = sprintf(moneyFormat, minTotal, minDecimals, '');
    const maxFormatted = sprintf(moneyFormat, maxTotal, maxDecimals, text.currency);
    return `${text.from} ${minFormatted} - ${maxFormatted}`;
  }
};



// WEBPACK FOOTER //
// ./frontend/react/utils/ticketprice/index.js